import * as XLSX from 'xlsx';

// Builds the Excel file for an order page: one row per order line, plus a TOTAL row.
// columns: [{ header, value: (order) => any, money?: true, sum?: true, width? }]
export function exportOrdersExcel({ title, columns, orders, startDate, endDate, orderKey }) {
  const rows = orders.map(o => columns.map(c => {
    const v = c.value(o);
    return c.money || c.sum ? (v === null || v === undefined || v === '' ? 0 : Number(v)) : (v ?? '');
  }));

  const distinctOrders = new Set(orders.map(orderKey)).size;
  const total = columns.map((c, i) => {
    if (i === 0) return `TOTAL (${distinctOrders} orders)`;
    if (!c.money && !c.sum) return '';
    const s = rows.reduce((acc, r) => acc + (Number(r[i]) || 0), 0);
    return c.money ? Math.round(s * 100) / 100 : s;
  });

  const range = startDate && endDate ? `${startDate} to ${endDate}` : 'all dates';
  const aoa = [[`${title} — ${range}`], [], columns.map(c => c.header), ...rows, [], total];
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  // money cells show as 0.00
  const firstData = 3;
  columns.forEach((c, ci) => {
    if (!c.money) return;
    for (let r = firstData; r < aoa.length; r++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c: ci })];
      if (cell && cell.t === 'n') cell.z = '#,##0.00';
    }
  });
  ws['!cols'] = columns.map(c => ({ wch: c.width || (c.money ? 12 : 14) }));
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ r: 2, c: 0 }, { r: 2 + rows.length, c: columns.length - 1 }) };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Orders');
  XLSX.writeFile(wb, `${title} ${range}.xlsx`.replace(/[\\/:*?"<>|]/g, '-'));
}

export const excelDate = (d) => {
  if (!d) return '';
  const t = new Date(d);
  return isNaN(t) ? String(d) : t.toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};
